export default __webpack_public_path__ + "static/media/cam.686300aa.svg";